import AxiosInstance from 'src/shared/services/axios/interceptor';
import { ArticleAccount, ArticleAccountRequest } from 'src/shared/models/invoiceGroup/articleAccount';

const controller = 'ArticleAccount';

export const getArticleAccountsByOwnerId = (ownerId: number) => {
  return AxiosInstance.get<ArticleAccount[]>(`${controller}/${ownerId}`);
};

export const saveArticleAccount = (data: ArticleAccountRequest) => {
  return AxiosInstance.put(controller, data);
};
